import React from 'react';
import {
  type UserReferenceElement,
  type ComponentProps,
} from '@aha-app/aha-editor-v2';

interface ReferenceUserComponentProps
  extends ComponentProps<UserReferenceElement> {}

const ReferenceUserComponent: React.FC<ReferenceUserComponentProps> = ({
  attributes,
  element,
  children,
}) => {
  if (element.reference_class === 'Ideas::PortalUser') {
    return (
      <span
        data-linked-element-type={element.reference_class}
        data-linked-element-id={element.reference_id}
        className='user-mention'
        {...attributes}
      >
        @{element.reference_name}
        {children}
      </span>
    );
  }

  return (
    <a
      href={element.reference_url}
      target='_blank'
      rel='noreferrer'
      className='user-mention'
      {...attributes}
    >
      @{element.reference_name}
      {children}
    </a>
  );
};

export default ReferenceUserComponent;
